import supported from '../../../../../../libs/shared-services/src/lib/constants/supported-languages.json';

/** The languages audatours.com can be switched to (supported-languages.json). */
export type LangCode = 'en' | 'es' | 'zh' | 'fr' | 'de' | 'ja' | 'it' | 'ko' | 'hi' | 'nl' | 'pl';

export interface Language {
  code: LangCode;
  name: string;
  nativeName: string;
}

export const LANGUAGES: Language[] = (supported as { code: string; name: string; nativeName: string }[])
  .map(l => ({ code: l.code as LangCode, name: l.name, nativeName: l.nativeName }));

export const DEFAULT_LANGUAGE: LangCode = 'en';

export const isLangCode = (code: unknown): code is LangCode =>
  typeof code === 'string' && LANGUAGES.some(l => l.code === code);

/** The page on audatours.com in a language: /fr/tour/..., English unprefixed. */
export const sitePath = (lang: LangCode, path: string) => (lang === 'en' ? path : `/${lang}${path === '/' ? '' : path}`);
